import api, { formDataInstance } from "./baseRequest";

export const menuCategoriesService = {
  getAllMenuCategories: () => {
    return api.get("/menu/categories");
  },

  getMenuCategoryById: (id) => {
    return api.get(`/menu/categories/${id}`);
  },

  createMenuCategory: ({ name, image }) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("image", image);
    return formDataInstance.post("/menu/categories", formData);
  },

  updateMenuCategory: (id, { name, image }) => {
    const formData = new FormData();
    if (name !== undefined) formData.append("name", name);
    if (image) formData.append("image", image);
    return formDataInstance.put(`/menu/categories/${id}`, formData);
  },

  deleteMenuCategory: (id) => {
    return api.delete(`/menu/categories/${id}`);
  },

  reorderMenuCategories: (categoryIds) => {
    return api.patch("/menu/categories/reorder", { categoryIds });
  },
};
